export const MIN_SEARCH_QUERY_LENGTH = 3;

export const normalizeSearchInput = (value: string): string => {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9@._\-\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const buildSearchIndex = (value: string): string[] => {
  const normalized = normalizeSearchInput(value);
  if (!normalized) return [];

  const words = normalized
    .split(/\s+/)
    .map(word => word.replace(/^@+/, '').replace(/^[._-]+|[._-]+$/g, ''))
    .filter(Boolean);

  const tokens = new Set<string>();

  for (const word of words) {
    if (!word) continue;
    tokens.add(word);

    for (let i = 3; i <= word.length; i++) {
      tokens.add(word.slice(0, i));
    }

    for (let start = 0; start + 2 < word.length; start += 1) {
      tokens.add(word.slice(start, start + 3));
    }
  }

  return [...tokens].filter(token => token.length >= 3);
};

export const canQuerySearch = (value: string) => normalizeSearchInput(value).length >= MIN_SEARCH_QUERY_LENGTH;
